module.exports = __webpack_public_path__ + "static/media/threat-watch.7e2a1c28.svg";